'use strict';

const base = require('./base').default;
const detail = require('./detail').default;
const { updateSelectedSwatchProductName, injectAfterpay, injectFitPredictor, updateFullProductLink } = require('../quickView/quickViewHelpers').default;
const focusHelper = require('base/components/focus');
const { getJSON } = require('../util');
const { getStyles, hasClass, queryFirst, remove, scrollTo } = require('../domUtil');
const { quickView: quickViewTemplates } = require('../templates');
const $body = $('body');
const { ajaxFormInvalid, ajaxFormSubmit } = require('../clientSideValidation');
const header = queryFirst('.main-header');

/**
 * OOTB function
 * Generates the modal window on the first call.
 * @param {HTMLElement} srcElement - quick view initiator element
 */
function getModalHtmlElement(srcElement) {
    const quickViewModalEl = document.getElementById('quickViewModal');
    remove(quickViewModalEl);
    const quickview = $(quickViewTemplates.quickViewModal);
    quickview.data('srcElement', srcElement);
    $('body').append(quickview);
}

/**
 * OOTB function
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));
    const body = $html.find('.product-quickview');
    return { body };
}

/**
 * Returns the additional offset that should be scrolled depending on whether the navigation menu is sticky
 * @returns {number} Main navigation offset
 */
function getNavOffset() {
    return hasClass(header, 'sticky') ? header.offsetHeight : 0;
}

/**
 * Function to attach form validation events
 */
function attachFormEvents() {
    const quickViewFormSelector = '.product-quickview form';
    ajaxFormInvalid(quickViewFormSelector);
    ajaxFormSubmit(quickViewFormSelector);
}

/**
 * OOTB function with changes
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {jQuery.event} event - Event object which trigger the action
 */
function fillModalElement(selectedValueUrl, event) {
    const quickViewModal = $('#quickViewModal');

    $.spinner().start();

    getJSON(selectedValueUrl, 'GET', null,
        data => {
            const { quickviewProductInfo } = data;
            var parsedHtml = parseHtml(data.renderedTemplate);

            if (quickViewModal) {
                quickViewModal.find('.modal-body').html(parsedHtml.body);
                quickViewModal.find('.size-chart').attr('href', data.productUrl);
                quickViewModal.find('.enter-message').text(data.enterDialogMessage);

                updateFullProductLink(data.quickViewFullDetailMsg, data.productUrl, quickViewModal);
                injectAfterpay(quickViewModal);
                injectFitPredictor(quickViewModal);

                if (quickviewProductInfo) {
                    window.quickviewProductInfo = quickviewProductInfo;
                    const swatchEl = quickViewModal.find('.color-attribute .swatch-value');
                    const selectedSwatchEl = quickViewModal.find('.color-attribute .swatch-value.selected');
                    const sizeElements = quickViewModal.find('.size-btn');
                    if (quickviewProductInfo && swatchEl.length && !selectedSwatchEl) {
                        quickViewModal.find('.color-attribute').eq(0).click();
                    }
                    if (selectedSwatchEl && sizeElements.length === 1 && !sizeElements.hasClass('selected')) {
                        sizeElements.click();
                    }
                }

                quickViewModal.modal('show');

                requestAnimationFrame(() => {
                    $body.trigger('quickview:visible');
                });

                // Only for Gift card quickview attach form events
                if (data.gcType) {
                    attachFormEvents();

                    if (data.gcType === 'pgc' && queryFirst('.cart-page')) {
                        const productLineItemEl = event.target.closest('.product-info-p-giftcard');
                        // Return if the line item is not pgiftcard
                        if (!productLineItemEl) {
                            return;
                        }

                        const lineItemAmountEl = queryFirst('.gift-card-amount', productLineItemEl);
                        if (lineItemAmountEl) {
                            quickViewModal
                                .find('.gift-card-custom-input-group .form-control')
                                .val(lineItemAmountEl.value)
                                .trigger('keyup');
                            quickViewModal
                                .find('.gift-card-amount')
                                .val(lineItemAmountEl.value);
                        }
                    }
                }
            }

            $.spinner().stop();
        },
        () => $.spinner().stop()
    );
}

module.exports = {
    showQuickview: () => {
        $body.on('click', `
            .cart-page .product-edit .edit,
            .cart-page .bundle-edit .edit`, e => {
            e.preventDefault();
            const $target = $(e.target);
            getModalHtmlElement($target);
            const selectedValueUrl = $target.data('href');
            fillModalElement(selectedValueUrl, e);
            $target.trigger('quickview:show');
        });

        $body.on('click', '.quickview-container .close-quickview', e => {
            const container = e.target.closest('.quickview-container');
            if (container) {
                const target = $(container).prev();
                const padding = parseInt(getStyles(container, 'padding-top'), 10);

                remove(container);
                $body.trigger('quickview:close');

                // Scroll back to the target row so the user doesn't lose their position
                scrollTo(target.offset().top - padding - getNavOffset(), 250);
            } else {
                $('#quickViewModal').modal('hide');
            }
        });

        $body.on('click', '.product-quickview .notify-me-btn', function (e) {
            e.preventDefault();
            $(this).closest('.product-quickview').find('#notifyMe').modal('show');
        });
    },
    focusQuickview: function () {
        $body.on('shown.bs.modal', '#quickViewModal', function () {
            $('#quickViewModal .close-quickview').focus();
        });
    },
    trapQuickviewFocus: function () {
        $body.on('keydown', '.product-quickview', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '.product-quickview',
                firstElementSelector: '.close-quickview',
                lastElementSelector: '.full-pdp-link',
                nextToLastElementSelector: '.add-to-cart'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    showSpinner: function () {
        $body.on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.product-quickview').spinner().start();
        });
    },
    sizeChart: detail.sizeChart,
    hideDialog: function () {
        $body.on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');

            const isCartPage = queryFirst('.cart-container');
            const addToCartWarningDialog = queryFirst('#add-to-cart-warning-dialog') || false;
            if (isCartPage && !addToCartWarningDialog) {
                location.reload();
            }
        });
    },
    beforeUpdateAttribute: function () {
        $body.on('product:beforeAttributeSelect', function () {
            $('.product-quickview').spinner().start();
        });
    },
    updateAttribute: function () {
        $body.on('product:afterAttributeSelect', function (e, response) {
            const quickView = response.container[0];

            if (hasClass(quickView, 'product-quickview')) {
                const { productDetailsUrl } = response.data.product;
                const fullPDPLink = queryFirst('.full-pdp-link', quickView);
                fullPDPLink.setAttribute('href', productDetailsUrl);

                updateSelectedSwatchProductName(response.data.product.variationAttributes, $(quickView));
            }
        });
    },
    updateAddToCart: function () {
        $body.on('product:updateAddToCart', function (e, response) {
            const quickView = queryFirst('.product-quickview');

            if (quickView) {
                const disabled = !response.product.readyToOrder || !response.product.available;

                let buttonToUpdate;
                const addToCartButton = queryFirst('button.add-to-cart', quickView);
                if (addToCartButton) {
                    buttonToUpdate = addToCartButton;
                } else {
                    const updateCartButton = queryFirst('.update-cart-product-global', quickView);
                    if (updateCartButton) {
                        buttonToUpdate = updateCartButton;
                    }
                }

                if (buttonToUpdate) {
                    if (disabled) {
                        buttonToUpdate.setAttribute('disabled', disabled);
                    } else {
                        buttonToUpdate.removeAttribute('disabled');
                    }
                }
            }
        });
    },
    updateAvailability: function () {
        $body.on('product:updateAvailability', function (e, response) {
            const quickView = queryFirst('.product-quickview');

            if (quickView) {
                $('.product-availability', response.$productContainer)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    }
};
